import React from 'react'
import { Grid } from '@material-ui/core'
import { SpacingContainer } from '../../../components/common/Containers'
import Typography from '../../../components/common/Typography'
import { useTrans } from '../../../services/i18n'
import SearchTopPanel from '../../../components/generics/SearchTopPanel'
import SortingPanel from '../../../components/generics/SortingPanel'
import ListInfoRow from '../../../components/generics/ListInfoRow'
import connect from '../connect'

const Header = ({ scope, adminEvents, onChangeOrder, onChangeFilters }) => {
  const { trans } = useTrans()
  const orderOptions = [
    {
      name: trans('date'),
      value: 'createdAt',
      asc: trans('oldest-first'),
      desc: trans('newest-first'),
    },
  ]
  const { filters, order, count, items } = adminEvents

  return (
    <>
      <SpacingContainer py={3} px={0}>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Typography
              weight='600'
              variant='h2'
              fontFamily='lexend'
              title
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {trans('admin-actions')}
            </Typography>
          </Grid>
        </Grid>
      </SpacingContainer>

      <SearchTopPanel
        scope={scope}
        filters={filters}
        onChangeFilters={onChangeFilters}
        filterOptions={[]}         
      />

      {!!items.length && (
        <ListInfoRow
          count={count}
          description={trans('results')}
          sort={
            <SortingPanel
              order={order}
              scope={scope}
              orderOptions={orderOptions}
              onChangeOrder={onChangeOrder}
            />
          }
        />
      )}
    </>
  )
}

export default connect(Header)
